import { ProductListPage } from './ProductList.page';

export const productListRouter = {
  '/@/products': ProductListPage,
  '/@/goods/products': ProductListPage,
  '/@/hand-made/products': ProductListPage,
  '/@/brand-deals/products': ProductListPage,
  '/@/ebooks/products': ProductListPage,
};
